function getPosAroundCircle(position, angle, radius) {
  return {
    x: position.x + Math.cos(angle) * radius,
    y: position.y + Math.sin(angle) * radius
  };
}
const getPositionOfNextUpdate = (position, velocity) => ({
  x: position.x + velocity.x * 1,
  y: position.y + velocity.y * 1
});
export {
  getPosAroundCircle,
  getPositionOfNextUpdate
};
//# sourceMappingURL=position.js.map
